// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FacebookRegistration__wrapper--34-","button":"FacebookRegistration__button--lAg","logo":"FacebookRegistration__logo--3vJ"};